const excludeKeys = ["elementId"] as const;

/**
 * Counts the number of dirty fields in the given object, excluding keys specified in excludeKeys.
 * @author @CorradoSurmanowicz
 */
export function calculateDirtyFields(obj: any): number {
  let count = 0;
  if (Array.isArray(obj)) {
    for (const item of obj) {
      count += calculateDirtyFields(item);
    }
  } else if (typeof obj === "object" && obj !== null) {
    for (const key in obj) {
      if (!Object.prototype.hasOwnProperty.call(obj, key) || (excludeKeys as readonly string[]).includes(key)) continue;
      count += calculateDirtyFields(obj[key]);
    }
  } else if (obj === true) {
    count += 1;
  }
  return count;
}
